import styled from 'styled-components';

export const PartyJackpotWelcomePopupImageContainerBox = styled.div`
    width: 185px;

    @media ${({theme}) => theme.mediaQuery.landscape} {
        width: 140px;
    }
`;
